import { useCallback } from "react";
import { useIntercom } from "react-use-intercom";

declare global {
    interface Window {
        Intercom?: unknown;
    }
}

export const useSupport = (() => {
    const { show } = useIntercom();

    const contactSupport = useCallback(() => {
        const intercomInstance = document.querySelector(".intercom-launcher");
        if (!intercomInstance) {
            window.open("mailto:support@workleap.com", "_blank");
        } else {
            show();
        }
    }, [show]);

    return {
        contactSupport
    };
});
